import { connect } from 'react-redux';
import checkExercise from '../actions/actionCreators/checkExercise';
import showExercise from '../actions/actionCreators/showExercise';
import { updateLostXp } from '../actions/actionCreators/updateLostXp';
import Exercise from '../components/Exercise';
const mapStateToProps = () => ({});
const mapsDispatchToProps = (dispatch, _ref) => {
  let {
    exerciseId,
    user
  } = _ref;
  return {
    checkExercise: (message, success, lastSubmittedCode) => dispatch(checkExercise({
      exerciseId,
      isLoggedIn: user.isLoggedIn,
      lastSubmittedCode,
      message,
      success
    })),
    showExercise: () => dispatch(showExercise(exerciseId)),
    updateLostXp: _ref2 => {
      let {
        exerciseId: id,
        lostXp
      } = _ref2;
      return dispatch(updateLostXp({
        exerciseId: id,
        lostXp
      }));
    }
  };
};
export default connect(mapStateToProps, mapsDispatchToProps)(Exercise);